/* unplugin-vue-components disabled */import { render } from "./childExhibitions.vue?vue&type=template&id=63eb2bb4&scoped=true"
import script from "./childExhibitions.vue?vue&type=script&lang=js"
export * from "./childExhibitions.vue?vue&type=script&lang=js"

import "./childExhibitions.vue?vue&type=style&index=0&id=63eb2bb4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb2bb4"]])

export default __exports__